// extracted by mini-css-extract-plugin
export default {"fullWidth":"Tn-z","image":"Un-z","lazyLoadPicture":"Vn-z","lazyLoadSpinner":"Wn-z","lazyLoadSpin":"Xn-z","lazyLoadImage":"Yn-z","hasStyledAspectRatio":"Zn-z"};